import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.submitTarget.disabled = true
  }

  inputChanged(_event) {
    this.#enableDisableSubmit()
  }

  #enableDisableSubmit() {
    let submitEnabled = true
    this.inputTargets.forEach(input => {
      submitEnabled = submitEnabled && (input.value.length > 0 || !input.attributes.required)
    })

    this.submitTarget.disabled = !submitEnabled
  }
}
